<template>
	<v-dialog
		v-model="value"
		persistent
		@keydown.esc="$emit('input', false)"
	>
		<v-toolbar color="grey lighten-2" tile>
			<v-toolbar-title class="poppins-semibold" style="font-size: 1rem">
			Vuoi cambiare il tuo nutrizionista?
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<v-icon @click="$emit('input', false)">fas fa-times</v-icon>
			</v-toolbar-items>
		</v-toolbar>
		<v-card tile>
			<v-container>
				<confirm ref="confirm"></confirm>

				<v-row v-if="loadingMatches">
					<v-col v-for="i in $vuetify.breakpoint.smAndDown ? 1:3" :key="i" >
						<v-skeleton-loader type="card"> </v-skeleton-loader>
					</v-col>
				</v-row>
				<div
					class="mx-auto mb-5"
					style="max-width: 600px;"
					v-if="!loadingMatches && $vuetify.breakpoint.smAndDown"
				>
					<v-carousel
						height="auto"
						next-icon="fas fa-angle-right"
						prev-icon="fas fa-angle-left"
						hide-delimiters
					>
						<v-carousel-item
							v-for="nutritionist in Options"
							:key="nutritionist.UserId"
							class=""
						>
							<div class="mx-3">
								<NutritionistProfileExpandableCard
									:matching-skills="
										nutritionist.MatchingSkills
									"
									:nutritionist-profile="
										nutritionist.NutritionistProfile
									"
									:nutritionist-tags="
										nutritionist.NutritionistTags
									"
								>
									<template v-slot:mail-button>
										<v-btn
											v-if="
												PatientProfile.DefaultNutritionistUserId !==
													nutritionist.userId
											"
											color="nyGreenAlt darken-2"
											class="text-transform-none"
											dark
											block
											large
											@click="
												ChangeNutritionist(
													nutritionist.userId
												)
											"
										>
											Cambia Nutrizionista
										</v-btn>

										<v-btn
											v-if="
												PatientProfile.DefaultNutritionistUserId ===
													nutritionist.userId
											"
											color="nyGreenAlt darken-2"
											class="text-transform-none"
											dark
											block
											large
											@click="$emit('input', false)"
										>
											Continua con
											{{
												nutritionist.NutritionistProfile
													.ApplicationUser.DisplayName
											}}
										</v-btn>
									</template>
								</NutritionistProfileExpandableCard>
							</div>

							<!--					carousel wasn't displaying properly the bottom of the v-card above-->
							<div class="mb-1"></div>
						</v-carousel-item>
					</v-carousel>
				</div>

				<v-row v-if="!loadingMatches && $vuetify.breakpoint.mdAndUp">
					<v-col
						v-for="nutritionist in Options"
						:key="nutritionist.UserId"
						cols="4"
					>
						<NutritionistProfileExpandableCard
							:matching-skills="nutritionist.MatchingSkills"
							:nutritionist-profile="
								nutritionist.NutritionistProfile
							"
							:nutritionist-tags="nutritionist.NutritionistTags"
						>
							<template v-slot:mail-button>
								<v-btn
									v-if="
										PatientProfile.DefaultNutritionistUserId !==
											nutritionist.userId
									"
									color="nyGreenAlt darken-2"
									class="text-transform-none"
									dark
									block
									large
									@click="
										ChangeNutritionist(nutritionist.userId)
									"
								>
									Cambia Nutrizionista
								</v-btn>

								<v-btn
									v-if="
										PatientProfile.DefaultNutritionistUserId ===
											nutritionist.userId
									"
									color="nyGreenAlt darken-2"
									class="text-transform-none"
									dark
									block
									large
								>
									Continua con
									{{
										nutritionist.NutritionistProfile
											.ApplicationUser.DisplayName
									}}
								</v-btn>
							</template>
						</NutritionistProfileExpandableCard>
					</v-col>
				</v-row>
			</v-container>
		</v-card>
	</v-dialog>
</template>
<script>
import NutritionistProfileExpandableCard from "@/views/Patients/components/NutritionistProfileExpandableCard.vue";
import CrudClient from "@/services/CrudClient";
import { mapActions } from "vuex";
import confirm from "@/components/Shared/Common/Confirm.vue";

export default {
	name: "MatchingNutritionists.vue",
	components: { confirm, NutritionistProfileExpandableCard },
	data() {
		return {
			Options: [],
			PatientProfile: null,
			loadingMatches: false
		};
	},
	props: {
		value: { required: true, type: Boolean }
	},

	created() {
		this.CurrentPatientProfileService = new CrudClient(
			"CurrentPatient/Profile"
		);

		this.CurrentPatientNutritionistService = new CrudClient(
			"CurrentPatient/Nutritionist"
		);
		this.PublicNutritionistsService = new CrudClient(
			"Nutritionists/Public"
		);

		this.UserTags = new CrudClient("SGP/UserTags");
	},
	async mounted() {
		try {
			this.loadingMatches = true;

			this.PatientProfile = await this.CurrentPatientProfileService.Get();

			const matchNutritionistIds = await this.CurrentPatientNutritionistService.Get(
				null,
				"MatchingNutritionists"
			);

			this.$log.debug({ matchNutritionistIds: matchNutritionistIds });

			for (let i = 0; i < matchNutritionistIds.length; i++) {
				const option = {};

				option.userId = matchNutritionistIds[i];
				option.MatchingSkills = await this.CurrentPatientNutritionistService.Get(
					"MatchingSkills/" + matchNutritionistIds[i]
				);

				option.NutritionistProfile = await this.PublicNutritionistsService.Get(
					matchNutritionistIds[i]
				);

				option.NutritionistTags = (
					await this.UserTags.Get("User/" + matchNutritionistIds[i])
				).Data;

				this.Options.push(option);
			}
		} catch (e) {
			this.$captureError(e);
		} finally {
			this.loadingMatches = false;
		}
		// this.NutritionistProfile = await this.PublicNutritionistsService.Get(
		// 	this.PatientProfile.DefaultNutritionistUserId
		// );
	},
	methods: {
		...mapActions(["snackSuccess", "snackError"]),

		async ChangeNutritionist(nutritionistId) {
			if (
				!(await this.$refs.confirm.open(
					this.$t("Cambio Nutrizionista"),
					this.$t("Vuoi cambiare il tuo nutrizionista?"),
					{ color: "warning" }
				))
			) {
				return;
			}

			try {
				this.loadingMatches = true;
				await this.CurrentPatientNutritionistService.Post(
					"ChangeNutritionist",
					{
						NutritionistId: nutritionistId
					},
					null
				);

				this.$emit("input", false);
				this.$emit("NutritionistChanged", nutritionistId);
			} catch (e) {
				this.$captureError(e);
				this.snackError({
					Text: this.$t("common.error.cannotLoadData")
				});
			} finally {
				this.loadingMatches = false;
			}
		}
	}
};
</script>

<style scoped lang="scss"></style>
